import React from 'react'

import { SponsorRequestForm } from './SponsorRequestForm'

export const SponsorRequestCreate = (): JSX.Element => {
  return <SponsorRequestForm isEdit={false} />
}
